module.exports = __webpack_public_path__ + "img/home-card2.a8094735.svg";